
export class GanttEditorOptions {

  // public onEditable: (node: GanttEditorTreeNode | {}) => boolean | { field: boolean, value: boolean };
  // public theme: Number;
  // public language: String;
  // public languages: Object;

  constructor() {
    // this.escapeUnicode = false;
    // this.sortObjectKeys = false;
    // this.history = true;
  }
}
